import { create } from "zustand";
import { usersService } from "../../modules/multiplayer/UsersService";
export const useParticipantsStore = create((set, get) => ({
    allUsers: [],
    setUsers: (users) => {
        set({ allUsers: users });
    },
    otherUsers: () => get().allUsers.filter((user) => user.clientId !== usersService.getLocalUser().clientId),
    mutedUsers: [],
    unmutedUsers: () => get()
        .otherUsers()
        .filter((user) => !get().mutedUsers.find((mutedUser) => mutedUser.clientId === user.clientId)),
    setMutedUsers: (users) => {
        set({ mutedUsers: users });
    }
}));
function updateParticipantsStore() {
    useParticipantsStore.getState().setUsers(Array.from(usersService.users.values()));
}
export function startParticipantsListener() {
    usersService.onUserAddedDelegate.add(updateParticipantsStore);
    usersService.onUserRemovedDelegate.add(updateParticipantsStore);
    updateParticipantsStore();
}
export function stopParticipantsListener() {
    usersService.onUserAddedDelegate.remove(updateParticipantsStore);
    usersService.onUserRemovedDelegate.remove(updateParticipantsStore);
}
